import { oneLine } from 'common-tags';
import { formatCurrency } from 'common/FormatUtilities';
import { Tooltip } from 'src/shared/design-system/Tooltip';
import { Line, Text, TextContainer } from './styles';

export const FeesTaxesLine = ({
  isFinal,
  salesTax,
  serviceFee,
}: {
  isFinal: boolean;
  salesTax: number;
  serviceFee: number;
}) => {
  const salesTaxText = salesTax ? `, ${isFinal ? `Taxes` : `Estimated Taxes`}: ${formatCurrency(salesTax)}` : '';
  const tooltip = oneLine`
    Service Fee: ${formatCurrency(serviceFee)}${salesTaxText}. 
    Purchases include a service fee to help cover the costs associated with order fulfillment.
  `;

  return (
    <Line>
      <TextContainer>
        <Text>Fees & Taxes</Text>
        <Tooltip content={tooltip} showInfoCircle positions={['right', 'top', 'bottom', 'left']} />
      </TextContainer>
      <Text> {formatCurrency(serviceFee + salesTax)}</Text>
    </Line>
  );
};
